import $ from "jquery";

(() => {
    const catalog = {
        init: function () {
            // Tax price trigger
            $(".tax-btn").on("click", function () {
                const $_ = $(this).parent(".tax-select");
                $_.next().next(".no-tax-price").hide();
                $_.next(".tax-price").show();
            });

            $(".no-tax-btn").on("click", function () {
                const $_ = $(this).parent(".tax-select");
                $_.next(".tax-price").hide();
                $_.next().next(".no-tax-price").show();
            });

            // Show all characteristics
            $(".all-characteristics").on("click", function (e) {
                let tab = $('.nav-tabs a[href="#tab-2"]');
                tab.tab("show");
                $("html, body").animate({scrollTop: tab.offset().top}, "slow");
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/catalog.js